exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row[data-v-2c6b2b26]{margin-left:0!important;margin-right:0!important}", ""]);

// exports
